export default {
  // 标题
  shareCanvas: "分享画布",

  // 加载
  loading: "拼命加载中",

  // 分享权限
  sharePermission: "分享权限",
  viewOnly: "仅查看",
  viewOnlyDescription: "不需要登录，输入密码即可访问",
  copyable: "可复制",
  copyableDescription: "需要登录，允许用户复制画布，输入密码即可访问",

  // 有效期
  validity: "有效期",
  pleaseSelect: "请选择",
  oneDay: "1天",
  threeDays: "3天",
  sevenDays: "7天",
  fourteenDays: "14天",
  thirtyDays: "30天",

  // 地址隐藏
  addressMasking: "地址隐藏",

  // 访问密码
  accessPassword: "访问密码",

  // 按钮
  copyLink: "复制链接",

  // 消息
  copySuccess: "复制成功",
};
